export var CheckListDataGrid = function (props) {
    // const { value, onChange } = props;
    // if (!value) return null;
    // const whatToCheckItems = value?.ChecklistFeedbackData?.filter((item:any) => item.QuestionGroupName === "What to check");
    // const howToConfirmItems = value?.ChecklistFeedbackData?.filter((item:any) => item.QuestionGroupName === "How to confirm");
    // const importanceItems = value?.ChecklistFeedbackData?.filter((item:any) => item.QuestionGroupName === "Importance");
    // const remarksData = value?.ChecklistFeedbackRemarkData || [];
    // const maxLength = Math.max(
    //     // whatToCheckItems.length, 
    //     // howToConfirmItems.length, 
    //     // importanceItems.length, 
    //     // remarksData.length
    // );
    // const rows = [];
    // for (let i = 0; i < 5; i++) {
    //     const row = {
    //         id: i + 1,
    //         SerialNumber: i + 1,
    //         whatToCheck: whatToCheckItems[i]?.Title || "",  
    //         howToConfirm: howToConfirmItems[i]?.Title || "",  
    //         importance: importanceItems[i]?.Title || "",  
    //         remarks: remarksData[i]?.Remarks || "",  
    //     };
    //     if (row.whatToCheck || row.howToConfirm || row.importance || row.remarks) {
    //         rows.push(row);
    //     }
    // }
    // const columns: IEditableDataGridProps["columns"] = [
    //     { type: "singleSelect", field: "SerialNumber", headerName: "Sr.No", editable: false, minWidth: 80, },
    //     { type: "string", field: "whatToCheck", headerName: "What to Check", editable: false, minWidth: 250, flex: 1 },
    //     { type: "string", field: "howToConfirm", headerName: "How to Confirm", editable: false, minWidth: 250, flex: 1 },
    //     { type: "string", field: "importance", headerName: "Importance", editable: false, minWidth: 250, flex: 1 },
    //     { type: "string", field: "remarks", headerName: "Remarks", editable: true, minWidth: 250, flex: 1 },  
    // ];
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ React.createElement("h4", null, "Coming soon...!"));
};
